import { USER_INFO_FETCHED, LOG_OUT } from "../types";

const INITIAL_STATE = {};

export default function user(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case USER_INFO_FETCHED:
      return action.data;
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
